import { useAccount } from 'modules/account/hooks/useAccount';
import { useSelectAccount } from 'modules/account/hooks/useSelectAccount';
import { useUser } from 'modules/user/hooks/useUser';

export const useSelectPersonalAccount = () => {
  const { address } = useUser();
  const { isAccountInitializing } = useAccount();

  const { selectAccount: handleSelectPersonalAccount } = useSelectAccount({
    accountAddress: address!,
  });

  return {
    handleSelectPersonalAccount,
    isPersonalAccountSelecting: isAccountInitializing,
  };
};
